/* eslint-disable no-unused-vars */
import styled from 'styled-components';

export const DisabledCreativesTitle = styled.div`
  color: #64748b;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  text-align: left;
  text-overflow: ellipsis;
  max-width: 200px;
  white-space: nowrap;
`;
export const CreativeDisplayLabels = styled.div`
  color: #334155;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  font-style: normal;
  text-align: left;
  text-overflow: ellipsis;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
`;
export const Titles = styled.div`
  color: #64748b;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  text-overflow: ellipsis;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
`;

export const ListContainer = styled.div`
  max-height: 280px;
  overflow-y: auto;
  margin-top: 8px;
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
